import * as React from 'react';

import * as styles from './ProjectsList.css';

interface IProjectsListProps {
  children: React.ReactNode;
}

export const ProjectsList: React.FC<IProjectsListProps> = ({ children }) => {
  return <div className={styles['list']}>{children}</div>;
};
